import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@adsk/bim360-matrix-react-button';

import './_SaveButton.scss';

/**
 * @class SaveButton
 */
export default class SaveButton extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = {
      isSaving: props.isSaving
    };

    this.onFinish = this.onFinish.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isSaving !== this.props.isSaving && nextProps.isSaving !== this.state.isSaving) {
      this.setState({ isSaving: nextProps.isSaving });
    }
  }

  onFinish() {
    this.mounted && this.setState({ isSaving: false });
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  /**
   *
   * @returns {XML}
   */
  render() {
    // eslint-disable-next-line no-unused-vars
    const { onSave, disabled, saveText, savingText, isSaving, ...rest } = this.props;
    const isSavingState = this.state.isSaving;

    const wrapperClasses = classNames('SaveButton__progress-button-wrapper', this.props.className);
    const buttonClasses = classNames('SaveButton__save-button', {
      'SaveButton__save-button--saving': isSavingState
    });
    return (
      <div className={wrapperClasses}>
        <Button
          {...rest}
          styleType={Button.StyleType.PRIMARY}
          className={buttonClasses}
          onClick={() => {
            const res = onSave();
            if (res && typeof res.then === 'function') {
              res.then(this.onFinish).catch(this.onFinish);
              this.setState({ isSaving: true });
            }
          }}
          disabled={disabled || isSavingState}
        >
          {isSavingState ? savingText : saveText}
        </Button>
      </div>
    );
  }
}

SaveButton.propTypes = {
  /**
   * A custom className for the save button
   */
  className: PropTypes.string,
  /**
   * On Save action. If returned a promise - saving state will be changed when promise is resolved or rejected.
   */
  onSave: PropTypes.func.isRequired,
  /**
   * Text to write the default button's text
   */
  saveText: PropTypes.string.isRequired,
  /**
   * Text to write when the button has been clicked
   */
  savingText: PropTypes.string.isRequired,
  /**
   * Whether or not the button is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Whether or not the form is currently saving.
   * Can be used either explicitly (using this prop) or retuning a promise in onSave
   */
  isSaving: PropTypes.bool
};
